const token = localStorage.getItem("token");console.log(token);
const auth = {
  headers: {
    authorization: `bearer ${token}`,
  },
};
export default auth;
